import {RootState} from '../../store';
import {SubscriptionItem} from './types';

export const selectionSelector = (state: RootState): Record<string, SubscriptionItem> =>
    state['subscription-items'].selection as Record<string, SubscriptionItem>;
